(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deliiston-ingredient-chapters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCarousels = (scope = document) => {
      scope.querySelectorAll('[data-di-carousel]').forEach((carousel) => {
        if (carousel.dataset.diReady === 'true') return;

        const track = carousel.querySelector('[data-di-track]');
        const previousButton = carousel.querySelector('[data-di-prev]');
        const nextButton = carousel.querySelector('[data-di-next]');

        if (!track) return;
        carousel.dataset.diReady = 'true';

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        const getStep = () => {
          const card = track.querySelector('.di-chapters__card');
          if (!card) return track.clientWidth;
          const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          return card.getBoundingClientRect().width + gap;
        };

        const updateControls = () => {
          const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const isScrollable = maximumScroll > 2;
          carousel.classList.toggle('is-scrollable', isScrollable);

          if (previousButton) previousButton.disabled = !isScrollable || track.scrollLeft <= 2;
          if (nextButton) nextButton.disabled = !isScrollable || track.scrollLeft >= maximumScroll - 2;
        };

        const setInitialPosition = () => {
          if (track.clientWidth === 0) return;

          if (carousel.dataset.initialPosition === 'last') {
            track.scrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
          } else {
            track.scrollLeft = 0;
          }

          updateControls();
        };

        const move = (direction) => {
          track.scrollBy({
            left: getStep() * direction,
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
          });
        };

        previousButton?.addEventListener('click', () => move(-1));
        nextButton?.addEventListener('click', () => move(1));
        track.addEventListener('scroll', updateControls, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            move(-1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            move(1);
          }
        });

        if ('ResizeObserver' in window) {
          new ResizeObserver(updateControls).observe(track);
        } else {
          window.addEventListener('resize', updateControls);
        }

        requestAnimationFrame(setInitialPosition);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeCarousels());
    } else {
      initializeCarousels();
    }

    document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('.di-chapters__card');
      if (!card) return;
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
